import React, { FC } from 'react';

import Image from 'next/image';

import dayjs from 'dayjs';

import DeletedIcon from '@/assets/help-center/deleted.svg';
import SelectedIcon from '@/assets/help-center/selected.svg';
import { useTranslate } from '@/hooks/use-translate';

import { TelegramIcon, WhatsAppIcon } from '../../Footer/icons';
import { en } from '../en';

import styles from './SupportServiceSection.module.scss';

export const SupportServiceSection: FC = () => {
	const t = useTranslate(en);

	const UTC = dayjs().utcOffset();

	const VladivostokTime = dayjs().add(-UTC, 'minute').add(10, 'hour');

	const isWorkTime = VladivostokTime.isBetween(
		VladivostokTime.startOf('day').hour(9),
		VladivostokTime.startOf('day').hour(18),
	);

	const getAvailableText = () => {
		return isWorkTime
			? t('Сейчас мы доступны')
			: t('Сейчас мы не доступны, но вы можете оставить нам сообщение');
	};
	return (
		<section className={styles.customerSupportSection}>
			<div className={styles.content}>
				<h2 className={styles.subtitle}>{t('Служба поддержки')}</h2>
				<div>
					<div className={styles.contacts}>
						<div className={styles.phone}>
							<a href="tel:+7 908 999 80 80">+7 908 999 80 80</a>
						</div>
						<div className={styles.mail}>
							<a href="mailto:hello@fishplace.ru">support@fishplace.ru</a>
						</div>
						<div className={styles.icons}>
							<a href="https://t.me/fishplaceru" target="_blank" rel="noreferrer">
								<TelegramIcon />
							</a>
							<a
								href="https://api.whatsapp.com/send?phone=79089998080"
								target="_blank"
								rel="noreferrer"
							>
								<WhatsAppIcon />
							</a>
						</div>
					</div>
					<div className={styles.additionalInfo}>
						{isWorkTime ? (
							<Image
								className={styles.icon}
								src={SelectedIcon}
								width={16}
								height={16}
								alt="select"
							/>
						) : (
							<Image
								className={styles.icon}
								src={DeletedIcon}
								width={16}
								height={16}
								alt="select"
							/>
						)}
						<div className={styles.text}>
							<div>{t('Работаем с 9:00 до 18:00 по Владивостоку')}</div>
							<div>{getAvailableText()}</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};
